import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { WebcamImage } from 'ngx-webcam';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  Observable,
  Subject,
  Subscription,
  tap,
} from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';
import { Visitor } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { environment } from 'src/app/environments/environments';
import {
  EncryptionService,
  UserDetailsToken,
} from 'src/app/services/Encryption/encryption.service';
@Component({
  selector: 'app-pre-approved-visitor-dialog',
  templateUrl: './pre-approved-visitor-dialog.component.html',
  styleUrls: ['./pre-approved-visitor-dialog.component.scss'],
})
export class PreApprovedVisitorDialogComponent implements OnInit {
  screenSize: ScreenType;
  showWebcam = false;

  private trigger: Subject<any> = new Subject();
  public webcamImage!: WebcamImage;
  private nextWebcam: Subject<any> = new Subject();
  sysImage = '';
  hostName = '';
  deviceSelected = '';
  availableDevices: any = [];
  isDeviceSelected = false;
  isManualVehicle = false;
  isEnable = false;
  isUniqueVisitor = true;
  isValid = true;
  visitors: Visitor[] = [];
  isDisabled = true;
  baseServerURL = environment.apiUrl;
  phoneForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });
  OrgId: string = null;
  printerAllowed = environment.printerAllowed;
  private phoneInputSubscription: Subscription | null = null;
  loggedUser: UserDetailsToken;
  constructor(
    private formbuilder: FormBuilder,
    private screen: AumyeResponsiveScreenService,
    private httpclient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public visitorData: any,
    private encryptionService: EncryptionService
  ) {
    this.loggedUser = this.encryptionService.getCurrentUser();
    this.OrgId = this.loggedUser.organizationID;
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
    this.setFormData();
  }
  ngOnDestroy(): void {
    if (this.phoneInputSubscription) {
      this.phoneInputSubscription.unsubscribe();
    }
  }
  resetFields(): void {
    this.visitorGateEntryPass.reset();
    this.isDisabled = true;
    this.isEnable = false;
    this.visitorGateEntryPass.controls.isReVisit.setValue(false);
    this.visitorGateEntryPass.controls.isPreApproved.setValue(true);
    this.visitorGateEntryPass.controls.sendQR.setValue(false);
    this.visitorGateEntryPass.controls.profilePicture.setValue('');
    this.visitors = [];
    this.isUniqueVisitor = true;
    this.isValid = true;
    this.showWebcam = false;
    this.isDeviceSelected = false;
    this.sysImage = '';
    this.visitorGateEntryPass.disable();
  }
  ngOnInit(): void {
    if (this.phoneInputSubscription) {
      this.phoneInputSubscription.unsubscribe();
    }
    this.phoneInputSubscription = this.phoneForm
      .get('phone')
      ?.valueChanges.pipe(
        debounceTime(500), // Wait 500ms for user input to stabilize
        distinctUntilChanged(), // Prevent duplicate calls for the same input
        filter(() => this.phoneForm.get('phone')?.valid), // Only valid inputs proceed
        tap(() => {
          if (!this.phoneForm.get('phone')?.valid) {
            this.resetFields();
          }
        }), // Reset fields before making API call
        tap((phoneNumber) => {
          this.checkPhoneNumber(phoneNumber);
        }) // Call the void function
      )
      .subscribe();
    this.phoneForm.get('phone')?.valueChanges.subscribe((value) => {
      if (!this.phoneForm.get('phone')?.valid) {
        this.resetFields();
      }
    });
    this.visitorGateEntryPass.disable();
    if (!navigator.mediaDevices?.enumerateDevices) {
      console.log('enumerateDevices() not supported.');
    } else {
      (async () => {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: false,
          video: true,
        });
        await navigator.mediaDevices
          .enumerateDevices()
          .then((devices) => {
            devices.forEach((device) => {
              if (device && device.kind === 'videoinput') {
                this.availableDevices.push(device);
              }
            });
          })
          .catch((err) => {
            console.error(`${err.name}: ${err.message}`);
          });
        stream.getTracks().forEach((track) => track.stop());
      })();
    }
  }

  visitorGateEntryPass = this.formbuilder.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['', [Validators.email]],
    phoneNumber: ['', Validators.required],
    visitorAddress: [''],
    purpose: ['', Validators.required],
    carRegistration: [],
    hostUserId: [''],
    hostEmail: [''],
    hostName: [''],
    profilePicture: ['', Validators.required],
    visitDateTime: [new Date().toISOString()],
    gender: [''],
    visitorID: ['', Validators.required],
    visitorCategory: ['', Validators.required],
    isPreApproved: [true],
    isReVisit: [false, Validators.required],
    previousVisitorId: [''],
    visitorTimline: [''],
    visitorCommentsTimeline: [''],
    selectedHosts: this.formbuilder.array([]),
    sendQR: [false],
  });
  userNames: string;
  setFormData() {
    if (this.visitorData?.isCluster) {
      this.userNames = this.visitorData.clusterIds
        .map((obj: any) => obj.hostName)
        .join(', ');
      let temp = this.visitorData.hostName + ', ' + this.userNames;
      this.visitorGateEntryPass.controls.hostName.setValue(temp);
    } else {
      this.visitorGateEntryPass.controls.hostName.setValue(
        this.visitorData.hostName
      );
    }

    // this.visitorGateEntryPass.controls.firstName.setValue(
    //   this.visitorData.firstName
    // );
    // this.visitorGateEntryPass.controls.lastName.setValue(
    //   this.visitorData.lastName
    // );
    this.visitorGateEntryPass.controls.email.setValue(this.visitorData.email);

    this.visitorGateEntryPass.controls.visitorCategory.setValue(
      this.visitorData.visitorCategory
    );
    this.visitorGateEntryPass.controls.visitorID.setValue(
      this.visitorData.visitorID
    );
    this.visitorGateEntryPass.controls.previousVisitorId.setValue(
      this.visitorData.visitorID
    );
    this.visitorGateEntryPass.controls.purpose.setValue('Delivery');
    this.visitorGateEntryPass.controls.visitorTimline.setValue(
      this.visitorData.visitorTimline
    );
    this.visitorGateEntryPass.controls.visitorCommentsTimeline.setValue(
      this.visitorData.visitorCommentsTimeline
    );
  }
  isApiCalled = false;
  checkPhoneNumber(phoneNumber: string): void {
    let baseServerURL = this.baseServerURL + 'CheckExistingVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .get(
        `${baseServerURL}?Number=${phoneNumber}&OrgId=${this.OrgId}&Type=2`,
        httpOptions
      )
      .subscribe(
        (response: any) => {
          this.isApiCalled = true;
          this.visitorGateEntryPass.reset();
          if (response.exists) {
            if (response.isValid) {
              this.isUniqueVisitor = false;
              this.isValid = response.isValid;
              this.visitors = response.visitor;
              this.setInputField();
              console.log(this.visitors);
            } else {
              this.visitors = [];
              this.visitors = response.visitor;
              console.log(this.visitors);
              this.isUniqueVisitor = false;
              this.isValid = false;
            }
          } else {
            this.setFormData();
            this.visitorGateEntryPass.enable();
            this.isUniqueVisitor = true;
            this.isDisabled = false;
            this.visitors = [];
            this.visitorGateEntryPass.controls.isReVisit.setValue(false);
            this.visitorGateEntryPass.controls.isPreApproved.setValue(true);
            this.visitorGateEntryPass.controls.sendQR.setValue(false);
            this.visitorGateEntryPass.controls.phoneNumber.setValue(
              this.phoneForm.value.phone
            );
          }
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }
  searchedImage: string = null;
  setInputField() {
    console.log('setInputField', this.visitors[0]);

    this.searchedImage = this.visitors[0].profilePicture;
    this.visitorSelect(this.visitors);
  }
  visitorSelect(val: Visitor[]) {
    const visitor: Visitor[] = val;
    const formArray = this.visitorGateEntryPass.get(
      'selectedHosts'
    ) as FormArray;
    formArray.clear();
    // visitor.forEach((x) => {
    //   const hostname = x.hostName;
    //   const hostId = x.hostUserId;
    //   if (hostname && !this.usersTemp.includes(hostname)) {
    //     this.usersTemp.push(hostname);
    //     const matchedUser = this.visitorData.orgUserList.find(
    //       (user) => user.userId.toLowerCase() === hostId.toLowerCase()
    //     );
    //     if (matchedUser) {
    //       const item = {
    //         HostName:
    //           matchedUser.firstname.trim() + ' ' + matchedUser.lastname.trim(),
    //         HostUserId: matchedUser.userId,
    //         HostEmail: matchedUser.email,
    //         HostPhone: matchedUser.phoneNumber,
    //       };
    //       this.selected.push(this.formbuilder.control(item));
    //     }
    //   }
    // });
    this.visitorGateEntryPass.controls.hostName.setValue(
      this.visitorData.hostName
    );
    this.visitorGateEntryPass.controls.firstName.setValue(visitor[0].firstName);
    this.visitorGateEntryPass.controls.lastName.setValue(visitor[0].lastName);
    this.visitorGateEntryPass.controls.email.setValue(visitor[0].email);
    this.visitorGateEntryPass.controls.phoneNumber.setValue(
      visitor[0].phoneNumber
    );
    this.visitorGateEntryPass.controls.visitorAddress.setValue(
      visitor[0].visitorAddress
    );
    // this.visitorGateEntryPass.controls.purpose.setValue(visitor[0].purpose);
    // this.visitorGateEntryPass.controls.hostUserId.setValue(visitor.hostUserId);
    // this.visitorGateEntryPass.controls.hostName.setValue(visitor.hostName);
    this.visitorGateEntryPass.controls.visitorCategory.setValue(
      this.visitorData.visitorCategory
    );
    // this.hostFilter.setValue(`${visitor[0].hostName}`);
    // this.visitorCtrl.setValue(`${visitor[0].firstName}`);
    this.visitorGateEntryPass.controls.isReVisit.setValue(true);
    this.visitorGateEntryPass.controls.isPreApproved.setValue(true);
    this.visitorGateEntryPass.controls.sendQR.setValue(false);
    this.visitorGateEntryPass.controls.visitorID.setValue(visitor[0].visitorID);
    this.visitorGateEntryPass.controls.previousVisitorId.setValue(
      this.visitorData.visitorID
    );
    this.visitorGateEntryPass.controls.visitorTimline.setValue(
      visitor[0].visitorTimline
    );
    this.visitorGateEntryPass.controls.visitorCommentsTimeline.setValue(
      visitor[0].visitorCommentsTimeline
    );
  }
  getSnapshot(): void {
    this.trigger.next(void 0);
    this.showWebcam = !this.showWebcam;
  }
  onChangeNumber(val: any) {}
  captureImg(webcamImage: WebcamImage): void {
    this.webcamImage = webcamImage;
    this.sysImage = webcamImage!.imageAsDataUrl;
    this.visitorGateEntryPass.controls.profilePicture.setValue(this.sysImage);
  }
  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
    this.showWebcam = true;
  }
  onDeviceSelectChange(val: any) {
    this.isDeviceSelected = true;
    this.showNextWebcam(val);
  }
  isChecked = false;
  onCheckboxChange() {
    if (this.isChecked) {
      this.visitorGateEntryPass.controls.sendQR.setValue(false);
      this.isChecked = false;
    } else {
      this.visitorGateEntryPass.controls.sendQR.setValue(true);
      this.isChecked = true;
    }
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  // hostSelect(val: any) {
  //   this.visitorData.orgUserList.forEach((item: any) => {
  //     if (item.userId === val) {
  //       this.hostName = item.firstname + ' ' + item.lastname;
  //       this.visitorGateEntryPass.controls.hostEmail.setValue(item.email);
  //     }
  //   });
  //   this.visitorGateEntryPass.controls.hostName.setValue(this.hostName);
  // }
  onChangeSelected(val: MatSelectChange) {
    if (val.value === 'manual') {
      this.isManualVehicle = true;
      this.visitorGateEntryPass.controls.carRegistration.setValue('');
    }
  }

  get invokeObservable(): Observable<any> {
    return this.trigger.asObservable();
  }
  get nextWebcamObservable(): Observable<any> {
    return this.nextWebcam.asObservable();
  }
  isManuallyCheck = false;
  onEditDetails() {
    this.isDisabled = false;
    this.visitorGateEntryPass.enable();
  }
  onManualCheckVisitor() {
    let val: any = this.visitors[0];
    val['isManualCheckout'] = true;
    let baseServerURL = this.baseServerURL + 'UpdateVisitor';
    let auth_token = localStorage.getItem('AccessToken');
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: auth_token,
      }),
    };
    this.httpclient
      .post(`${baseServerURL}`, val, {
        headers: httpOptions.headers,
        responseType: 'text',
      })
      .subscribe(
        (response: any) => {
          this.setInputField();
          this.isValid = true;
          this.isManuallyCheck = true;
          this.visitorGateEntryPass.disable();
          this.visitorGateEntryPass.controls.phoneNumber.setValue(
            this.phoneForm.value.phone
          );
        },
        (error) => {
          console.error('Error checking phone number', error);
        }
      );
  }

  ScreenType = ScreenType;
}
